module.exports = __webpack_public_path__ + "static/img/TimTszyu.ef02874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TimTszyu.jpg
// module id = 1DNJ
// module chunks = 0